/**
 * Unified app configuration url prefix for all different routes (legacy app is just "/")
 */
export const TALENTSEARCH_PREFIX = '/talentsearch';
